const Welcome = () => import('../view/welcome')
const ArticleDetails = () => import('../view/content/article-details')
const ArticleList = () => import('../view/content/article-list')
const VideoList = () => import('../view/content/video-list')
const ExpertBase = () => import('../view/separate/expert-base')
const KnowledgeBase = () => import('../view/separate/knowledge-base')
const MembersHome = () => import('../view/separate/members-home')
const Contribute = () => import('../view/content/contribute')
const StationSearch = () => import('../view/content/station-search')
const Expertcenter = () => import('../view/content/expertcenter')
const Cfbb = () => import('../view/content/cfbb')
const CfbbInvite = () => import('../view/content/cfbb-invite')
const Personalcenter = () => import('../view/content/personal-center')
const Recharge = () => import('../view/content/recharge')
export default [
  {
    path: '/Welcome',
    name: 'Welcome',
    component: Welcome
  },
  {
    path: '/station-search',
    name: 'station-search',
    component: StationSearch
  },
  {
    path: '/article-details',
    name: 'article-details',
    component: ArticleDetails
  },
  {
    path: '/article-list',
    name: 'article-list',
    component: ArticleList
  },
  {
    path: '/video-list',
    name: 'video-list',
    component: VideoList
  },
  {
    path: '/expert-base',
    name: 'expert-base',
    component: ExpertBase
  },
  {
    path: '/knowledge-base',
    name: 'knowledge-base',
    component: KnowledgeBase
  },
  {
    path: '/members-home',
    name: 'members-home',
    component: MembersHome
  },
  {
    path: '/contribute',
    name: 'contribute',
    component: Contribute
  },
  {
    path: '/expertcenter',
    name: 'expertcenter',
    component: Expertcenter
  },
  {
    path: '/cfbb',
    name: 'cfbb',
    component: Cfbb
  },
  {
    path: '/cfbb-invite',
    name: 'cfbb-invite',
    component: CfbbInvite
  },
  {
    path: '/personal-center',
    name: 'personal-center',
    component: Personalcenter
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: Recharge
  }
]
